<div class="row animated fadeIn">
    <div class="col-md-12">
        <div class="d-flex justify-content-between align-items-center mb-2">
            <h4 class="mb-0"><a href="javascript:void(0);" routerLink="/inquiry/inquirylist"><span
                        class="mdi mdi-arrow-left"></span></a> Edit Inquiry</h4>
        </div>

        <div class="card" style="margin-bottom: 250px;">
            <div class="card-body">
                <ngb-tabset #t="ngbTabset" [(activeId)]="active">
                    <ngb-tab id="tab-selectbyid1">
                        <ng-template ngbTabTitle>
                            <div (click)="tabclick(id)"> Edit Inquiry </div>
                        </ng-template>
                        <ng-template ngbTabContent>
                            <form [formGroup]="registerForm" autocomplete="off">
                                <div class="form-row mt-3">
                                    <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                        <label for=""
                                            class="d-inline-block justify-content-between align-items-center">Project
                                            Name (Project ID)<span class="required ml-1">*</span>
                                        </label>
                                        <input class="form-control" type="text"
                                            [ngClass]="{ 'is-invalid': submitted && f.ProjectName.errors }"
                                            formControlName="ProjectName" placeholder="Project Name" value="ProjectName"
                                            disabled title="{{Pname}}({{Pnumber}})" />
                                    </div>
                                    <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                        <label for=""
                                            class="d-inline-block justify-content-between align-items-center">Inquiry
                                            Name (Inquiry ID)<span class="required ml-1">*</span>
                                        </label>
                                        <input class="form-control" type="text" formControlName="InquiryName"
                                            value="InquiryName" placeholder="Inquiry Name"
                                            title="{{Iname}} ({{Inumber}})" disabled />
                                    </div>
                                    <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                        <label for="" class="d-inline-block justify-content-between align-items-center">
                                            Customer Name<span class="required ml-1">*</span>
                                        </label>
                                        <angular2-multiselect formControlName="CustomerName" [data]="showCustomer"
                                            [(ngModel)]="selectedcustomer" [settings]="dropdownSetting3"
                                            (onSelect)="onCustomerSelect($event)"
                                            (onDeSelect)="onCustomerSelect($event)"
                                            (onSelectAll)="onCustomerSelect($event)"
                                            (onDeSelectAll)="onCustomerSelect($event)" title="{{selectedCustomer}}"
                                            fixSearchBug>
                                        </angular2-multiselect>
                                        <div
                                            *ngIf="registerForm.get('CustomerName').invalid && registerForm.get('CustomerName').errors && (registerForm.get('CustomerName').dirty || registerForm.get('CustomerName').touched) || submitted">
                                            <small class="text-danger"
                                                *ngIf="registerForm.get('CustomerName').hasError('required')">
                                                Customer Name is Required.
                                            </small>
                                        </div>
                                    </div>
                                    <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                        <label for=""
                                            class="d-inline-block justify-content-between align-items-center">Business
                                            Vertical<span class="required ml-1">*</span>
                                        </label>
                                        <angular2-multiselect formControlName="BusinessVertical"
                                            [data]="businessVertical" [(ngModel)]="selectedBusiness"
                                            [settings]="dropdownSetting12" (onSelect)="onBusinessSelect($event)"
                                            (onDeSelect)="onBusinessSelect($event)"
                                            (onSelectAll)="onBusinessSelect($event)"
                                            (onDeSelectAll)="onBusinessSelect($event)" fixSearchBug
                                            title="{{selectedBusinessName}}">
                                        </angular2-multiselect>
                                        <div
                                            *ngIf="registerForm.get('BusinessVertical').invalid && registerForm.get('BusinessVertical').errors && (registerForm.get('BusinessVertical').dirty || registerForm.get('BusinessVertical').touched) || submitted">
                                            <small class="text-danger"
                                                *ngIf="registerForm.get('BusinessVertical').hasError('required')">
                                                Business Vertical is Required.
                                            </small>
                                        </div>
                                    </div>
                                    <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                        <label for=""
                                            class="d-inline-block justify-content-between align-items-center">Stages<span
                                                class="required ml-1">*</span>
                                        </label>
                                        <angular2-multiselect formControlName="StageId" [data]="showStage"
                                            [(ngModel)]="selectedstage" [settings]="dropdownSetting8"
                                            (onSelect)="onStageSelect($event)" (onDeSelect)="onStageSelect($event)"
                                            (onSelectAll)="onStageSelect($event)"
                                            (onDeSelectAll)="onStageSelect($event)" fixSearchBug
                                            title="{{selectedStage}}">
                                        </angular2-multiselect>
                                        <div
                                            *ngIf="registerForm.get('StageId').invalid && registerForm.get('StageId').errors && (registerForm.get('StageId').dirty || registerForm.get('StageId').touched) || submitted">
                                            <small class="text-danger"
                                                *ngIf="registerForm.get('StageId').hasError('required')">
                                                Stage is Required.
                                            </small>
                                        </div>
                                    </div>
                                    <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                        <label for=""
                                            class="d-inline-block justify-content-between align-items-center">Inquiry
                                            Probability<span class="required ml-1">*</span>
                                        </label>
                                        <angular2-multiselect formControlName="InquiryProbability"
                                            [data]="showProbability" [(ngModel)]="selectedprobability"
                                            [settings]="dropdownSetting9" (onSelect)="onProbabilitySelect($event)"
                                            (onDeSelect)="onProbabilitySelect($event)"
                                            (onSelectAll)="onProbabilitySelect($event)"
                                            (onDeSelectAll)="onProbabilitySelect($event)" fixSearchBug
                                            title="{{selectedProbability}}">
                                        </angular2-multiselect>
                                        <div
                                            *ngIf="registerForm.get('InquiryProbability').invalid && registerForm.get('InquiryProbability').errors && (registerForm.get('InquiryProbability').dirty || registerForm.get('InquiryProbability').touched) || submitted">
                                            <small class="text-danger"
                                                *ngIf="registerForm.get('InquiryProbability').hasError('required')">
                                                Inquiry Probability is Required.
                                            </small>
                                        </div>
                                    </div>
                                    <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                        <label for="" class="d-inline-block justify-content-between align-items-center">
                                            Received Date<span class="required ml-1">*</span>
                                        </label>
                                        <div class="input-group">
                                            <input type="text" class="bg-calender-icon form-control"
                                                id="inlineFormInputGroup" placeholder="DD-MM-YYYY" bsDatepicker
                                                [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY'}"
                                                formControlName="ReceivedDate" (keydown)="disableDate()" disabled
                                                readonly title="{{ReceivedDate}}">
                                        </div>
                                        <div
                                            *ngIf="registerForm.get('ReceivedDate').invalid && registerForm.get('ReceivedDate').errors && (registerForm.get('ReceivedDate').dirty || registerForm.get('ReceivedDate').touched) || submitted">
                                            <small class="text-danger"
                                                *ngIf="registerForm.get('ReceivedDate').hasError('required')">
                                                Received Date is Required.
                                            </small>
                                        </div>
                                    </div>
                                    <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                        <label for="" class="d-inline-block justify-content-between align-items-center">
                                            Quotation Engineer<span class="required ml-1">*</span>
                                        </label>
                                        <angular2-multiselect [data]="showQuotationEr"
                                            formControlName="QuotationEngineerId" [(ngModel)]="selectedquotationEr"
                                            [settings]="dropdownSetting10" (onSelect)="onQuotationErSelect($event)"
                                            (onDeSelect)="onQuotationErSelect($event)"
                                            (onSelectAll)="onQuotationErSelect($event)"
                                            (onDeSelectAll)="onQuotationErSelect($event)" fixSearchBug
                                            title="{{selectedQuotationEr}}">
                                        </angular2-multiselect>
                                        <div
                                            *ngIf="registerForm.get('QuotationEngineerId').invalid && registerForm.get('QuotationEngineerId').errors && (registerForm.get('QuotationEngineerId').dirty || registerForm.get('QuotationEngineerId').touched) || submitted">
                                            <small class="text-danger"
                                                *ngIf="registerForm.get('QuotationEngineerId').hasError('required')">
                                                Quotation Engineer is Required.
                                            </small>
                                        </div>
                                    </div>
                                    <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                        <label for="" class="d-inline-block justify-content-between align-items-center">
                                            Sales
                                            Engineer<span class="required ml-1">*</span>
                                        </label>
                                        <angular2-multiselect formControlName="SalesEngineerId" [data]="showSalesEr"
                                            [(ngModel)]="selectedsalesEr" [settings]="dropdownSetting11"
                                            (onSelect)="onSalesErSelect($event)" (onDeSelect)="onSalesErSelect($event)"
                                            (onSelectAll)="onSalesErSelect($event)"
                                            (onDeSelectAll)="onSalesErSelect($event)" fixSearchBug
                                            title="{{selectedSalesEr}}">
                                        </angular2-multiselect>
                                        <div
                                            *ngIf="registerForm.get('SalesEngineerId').invalid && registerForm.get('SalesEngineerId').errors && (registerForm.get('SalesEngineerId').dirty || registerForm.get('SalesEngineerId').touched) || submitted">
                                            <small class="text-danger"
                                                *ngIf="registerForm.get('SalesEngineerId').hasError('required')">
                                                Sales Engineer is Required.
                                            </small>
                                        </div>
                                    </div>
                                    <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                        <label for="" class="d-flex justify-content-between align-items-center">MEP
                                            Contractor
                                        </label>
                                        <angular2-multiselect formControlName="MEPContractor" [data]="showContractor"
                                            [(ngModel)]="selectedcontractor" [settings]="dropdownSetting4"
                                            (onSelect)="onContractorSelect($event)"
                                            (onDeSelect)="onContractorSelect($event)"
                                            (onSelectAll)="onContractorSelect($event)"
                                            (onDeSelectAll)="onContractorSelect($event)" fixSearchBug
                                            title="{{selectedContractor}}">
                                        </angular2-multiselect>
                                    </div>
                                    <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                        <label for="" class="d-flex justify-content-between align-items-center">Main
                                            Contractor
                                        </label>
                                        <angular2-multiselect formControlName="MainContractor"
                                            [data]="showMainContractor" [(ngModel)]="selectedMaincontractor"
                                            [settings]="dropdownSetting5" (onSelect)="onMainContractorSelect($event)"
                                            (onDeSelect)="onMainContractorSelect($event)"
                                            (onSelectAll)="onMainContractorSelect($event)"
                                            (onDeSelectAll)="onMainContractorSelect($event)" fixSearchBug
                                            title="{{selectedMainContractor}}">
                                        </angular2-multiselect>
                                    </div>
                                    <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                        <label for="" class="d-flex justify-content-between align-items-center">Design
                                            Consultant
                                        </label>
                                        <angular2-multiselect formControlName="DesignConsultant" [data]="showConsultant"
                                            [(ngModel)]="selectedconsultant" [settings]="dropdownSetting6"
                                            (onSelect)="onConsultantSelect($event)"
                                            (onDeSelect)="onConsultantSelect($event)"
                                            (onSelectAll)="onConsultantSelect($event)"
                                            (onDeSelectAll)="onConsultantSelect($event)" fixSearchBug
                                            title="{{selectedConsultant}}">
                                        </angular2-multiselect>
                                    </div>
                                    <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                        <label for=""
                                            class="d-flex justify-content-between align-items-center">Supervision
                                            Consultant
                                        </label>
                                        <angular2-multiselect formControlName="SupervisionConsultant"
                                            [data]="showSupervision" [(ngModel)]="selectedsupervision"
                                            [settings]="dropdownSetting7" (onSelect)="onSupervisionSelect($event)"
                                            (onDeSelect)="onSupervisionSelect($event)"
                                            (onSelectAll)="onSupervisionSelect($event)"
                                            (onDeSelectAll)="onSupervisionSelect($event)" fixSearchBug
                                            title="{{selectedSupervision}}">
                                        </angular2-multiselect>
                                    </div>
                                    <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                        <label for="" class="d-inline-block justify-content-between align-items-center">
                                            Total Quoted Value<span *ngIf="currencyName">({{currencyName}})</span>
                                        </label>
                                        <input class="form-control" type="text" formControlName="QuotedValue"
                                            value="QuotedValue" placeholder="Quoted Value" title="{{Qvalue}}"
                                            disabled />
                                    </div>

                                    <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                        <label for="" class="d-flex justify-content-between align-items-center">
                                            Total Reported Value (QAR)
                                        </label>
                                        <input class="form-control" type="text" formControlName="ReportedValue"
                                            value="ReportedValue" placeholder="Reported Value" title="{{Rvalue}}"
                                            disabled />
                                    </div>
                                    <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                        <label for="" class="d-flex justify-content-between align-items-center"> Quoted
                                            Date
                                        </label>
                                        <input class="form-control" type="text" formControlName="QuotedDate"
                                            [(ngModel)]="QuotedDate" disabled title="{{QuotedDate}}" />
                                    </div>

                                    <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                        <label for="" class="d-flex justify-content-between align-items-center">
                                            Delivery Period
                                        </label>
                                        <input class="form-control" type="text" formControlName="DeliveryPeriod"
                                            placeholder="Delivery Period" disabled title="{{DPeriod}}" />
                                    </div>

                                    <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                        <label for="" class="d-flex justify-content-between align-items-center">
                                            Application
                                        </label>
                                        <input class="form-control" type="text" formControlName="Application" disabled
                                            placeholder="Application Name" title="{{AppName}}" />
                                    </div>
                                    <div class="form-group col-lg-3 col-md-6 col-sm-12" *ngIf="QuotedDate">
                                        <label for="" class="d-flex justify-content-between align-items-center"> Exp.
                                            Order Date
                                        </label>
                                        <div class="input-group">
                                            <input type="text" class="bg-calender-icon form-control"
                                                id="inlineFormInputGroup" placeholder="DD-MM-YYYY" [minDate]="minDate"
                                                bsDatepicker [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY'}"
                                                (keydown)="disableDate()" formControlName="ExpOrderDate"
                                                autocomplete="false" title="{{ExpODate}}">
                                            <sapn class="position-absolute"
                                                *ngIf="registerForm.get('ExpOrderDate').value!=''"
                                                style="top: 50%; right: 5%; transform: translate(-50%, -50%);">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                    fill="currentColor" class="bi bi-x" viewBox="0 0 16 16"
                                                    (click)="cleardate()">
                                                    <path
                                                        d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                                </svg>
                                            </sapn>
                                        </div>
                                    </div>
                                    <div *ngIf="QuotedDate" class="form-group col-lg-3 col-md-6 col-sm-12">
                                        <label for="" class="d-flex justify-content-between align-items-center"> Quote
                                            Margin %
                                        </label>
                                        <input class="form-control" type="text" formControlName="QuoteMargin"
                                            appTwoDigitDecimaNumber maxlength="6" title="{{QMargin}}" />
                                        <div
                                            *ngIf="registerForm.get('QuoteMargin').invalid && registerForm.get('QuoteMargin').errors && (registerForm.get('QuoteMargin').dirty || registerForm.get('QuoteMargin').touched) || submitted">
                                            <small class="text-danger"
                                                *ngIf="registerForm.get('QuoteMargin').hasError('max')">
                                                Quote margin can not be greater than 100
                                            </small>
                                        </div>
                                        <div
                                            *ngIf="registerForm.get('QuoteMargin').invalid && registerForm.get('QuoteMargin').errors && (registerForm.get('QuoteMargin').dirty || registerForm.get('QuoteMargin').touched) || submitted">
                                            <small class="text-danger"
                                                *ngIf="registerForm.get('QuoteMargin').hasError('min')">
                                                Quote margin can not be less than 0
                                            </small>
                                        </div>
                                        <div
                                            *ngIf="registerForm.get('QuoteMargin').invalid && registerForm.get('QuoteMargin').errors && (registerForm.get('QuoteMargin').dirty || registerForm.get('QuoteMargin').touched) || submitted">
                                            <small class="text-danger"
                                                *ngIf="registerForm.get('QuoteMargin').hasError('pattern')">
                                                Invalid Value
                                            </small>
                                        </div>
                                    </div>
                                    <div *ngIf="Lost==true" class="form-group col-lg-3 col-md-6 col-sm-12">
                                        <label for=""
                                            class="d-inline-block justify-content-between align-items-center">Lost
                                            Company To
                                            <span class="required ml-1">*</span>
                                        </label>
                                        <angular2-multiselect formControlName="LostTo" [data]="showLostToCompany"
                                            [(ngModel)]="selectedcompany" [settings]="dropdownSetting18"
                                            (onSelect)="onCompanySelect($event)" (onDeSelect)="onCompanySelect($event)"
                                            (onSelectAll)="onCompanySelect($event)"
                                            (onDeSelectAll)="onCompanySelect($event)" title="{{selectedCompany}}"
                                            fixSearchBug>
                                        </angular2-multiselect>
                                        <div
                                            *ngIf="registerForm.get('LostTo').invalid && registerForm.get('LostTo').errors && (registerForm.get('LostTo').dirty || registerForm.get('LostTo').touched) || submitted">
                                            <small class="text-danger"
                                                *ngIf="registerForm.get('LostTo').hasError('required')">
                                                Lost To is Required.
                                            </small>
                                        </div>
                                    </div>
                                    <div *ngIf="Lost==true" class="form-group col-lg-3 col-md-6 col-sm-12">
                                        <label for="" class="d-inline-block justify-content-between align-items-center">
                                            Reason<span class="required ml-1">*</span>
                                        </label>
                                        <angular2-multiselect formControlName="Reason" [data]="showReason"
                                            [(ngModel)]="selectedreason" [settings]="dropdownSetting14"
                                            (onSelect)="onReasonSelect($event)" (onDeSelect)="onReasonSelect($event)"
                                            (onSelectAll)="onReasonSelect($event)"
                                            (onDeSelectAll)="onReasonSelect($event)" fixSearchBug
                                            title="{{selectedReason}}">
                                        </angular2-multiselect>
                                        <div *ngIf="rqdReason == true">
                                            <small class="text-danger">
                                                Reason is Required.
                                            </small>
                                        </div>
                                    </div>

                                    <div *ngIf="RL" class="form-group col-lg-3 col-md-6 col-sm-12">
                                        <label for=""
                                            class="d-inline-block justify-content-between align-items-center">Reason
                                            Description<span class="required ml-1">*</span>
                                        </label>
                                        <textarea class="form-control" formControlName="LostReason" maxlength="200"
                                            (input)="validateReasonDes($event)" title="{{reasonDes}}"></textarea>
                                        <div *ngIf="rqdReasonDes == true">
                                            <small class="text-danger">
                                                Reason Description is Required.
                                            </small>
                                        </div>
                                    </div>

                                    <div *ngIf="loi==true" class="form-group col-lg-3 col-md-6 col-sm-12">
                                        <label for="" class="d-inline-block justify-content-between align-items-center">
                                            LOI
                                            Margin %<span class="required ml-1">*</span>
                                        </label>
                                        <input class="form-control" type="text" formControlName="LOIMargin"
                                            appTwoDigitDecimaNumber maxlength="6" [required]="required"
                                            title="{{LMargin}}" />
                                        <div
                                            *ngIf="registerForm.get('LOIMargin').invalid && registerForm.get('LOIMargin').errors && (registerForm.get('LOIMargin').dirty || registerForm.get('LOIMargin').touched) || submitted">
                                            <small class="text-danger"
                                                *ngIf="registerForm.get('LOIMargin').hasError('max')">
                                                LOI margin can not be greater than 100
                                            </small>
                                        </div>
                                        <div
                                            *ngIf="registerForm.get('LOIMargin').invalid && registerForm.get('LOIMargin').errors && (registerForm.get('LOIMargin').dirty || registerForm.get('LOIMargin').touched) || submitted">
                                            <small class="text-danger"
                                                *ngIf="registerForm.get('LOIMargin').hasError('min')">
                                                LOI margin can not be less than 0
                                            </small>
                                        </div>
                                        <div
                                            *ngIf="registerForm.get('LOIMargin').invalid && registerForm.get('LOIMargin').errors && (registerForm.get('LOIMargin').dirty || registerForm.get('LOIMargin').touched) || submitted">
                                            <small class="text-danger"
                                                *ngIf="registerForm.get('LOIMargin').hasError('pattern')">
                                                Invalid Value
                                            </small>
                                        </div>
                                        <div
                                            *ngIf="registerForm.get('LOIMargin').invalid && registerForm.get('LOIMargin').errors && (registerForm.get('LOIMargin').dirty || registerForm.get('LOIMargin').touched) || submitted">
                                            <small class="text-danger"
                                                *ngIf="registerForm.get('LOIMargin').hasError('required')">
                                                LOI Margin is required
                                            </small>
                                        </div>
                                    </div>
                                    <div *ngIf="won==true" class="form-group col-lg-3 col-md-6 col-sm-12">
                                        <label for=""
                                            class="d-inline-block justify-content-between align-items-center">SO
                                            Margin %<span class="required ml-1">*</span>
                                        </label>
                                        <input class="form-control" type="text" appTwoDigitDecimaNumber
                                            formControlName="SOMargin" maxlength="6" [required]="required"
                                            title="{{SMargin}}" />
                                        <div
                                            *ngIf="registerForm.get('SOMargin').invalid && registerForm.get('SOMargin').errors && (registerForm.get('SOMargin').dirty || registerForm.get('SOMargin').touched) || submitted">
                                            <small class="text-danger"
                                                *ngIf="registerForm.get('SOMargin').hasError('max')">
                                                SO margin can not be greater than 100
                                            </small>
                                        </div>
                                        <div
                                            *ngIf="registerForm.get('SOMargin').invalid && registerForm.get('SOMargin').errors && (registerForm.get('SOMargin').dirty || registerForm.get('SOMargin').touched) || submitted">
                                            <small class="text-danger"
                                                *ngIf="registerForm.get('SOMargin').hasError('min')">
                                                SO margin can not be less than 0
                                            </small>
                                        </div>
                                        <div
                                            *ngIf="registerForm.get('SOMargin').invalid && registerForm.get('SOMargin').errors && (registerForm.get('SOMargin').dirty || registerForm.get('SOMargin').touched) || submitted">
                                            <small class="text-danger"
                                                *ngIf="registerForm.get('SOMargin').hasError('pattern')">
                                                Invalid Value
                                            </small>
                                        </div>
                                        <div
                                            *ngIf="registerForm.get('SOMargin').invalid && registerForm.get('SOMargin').errors && (registerForm.get('SOMargin').dirty || registerForm.get('SOMargin').touched) || submitted">
                                            <small class="text-danger"
                                                *ngIf="registerForm.get('SOMargin').hasError('required')">
                                                SO Margin is required
                                            </small>
                                        </div>
                                    </div>
                                    <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                        <label for="" class="d-flex justify-content-between align-items-center">
                                            Revision
                                        </label>
                                        <angular2-multiselect formControlName="Revision" [data]="showRevision"
                                            [(ngModel)]="selectedrevision2" [settings]="dropdownSetting15"
                                            (onSelect)="onRevisionSelect2($event)"
                                            (onDeSelect)="onRevisionSelect2($event)"
                                            (onSelectAll)="onRevisionSelect2($event)"
                                            (onDeSelectAll)="onRevisionSelect2($event)" fixSearchBug
                                            title="{{selectedRevision2}}">
                                        </angular2-multiselect>
                                    </div>
                                    <div class="form-group col-lg-3 col-md-6 col-sm-12" *ngIf="selectedRevisionId2!=0">
                                        <label for="" class="d-flex justify-content-between align-items-center">
                                            Revision Note
                                        </label>
                                        <textarea class="form-control" formControlName="RevisionNote"
                                            placeholder="RevisionNote" maxlength="500" title="{{RvsnNote}}"></textarea>
                                    </div>
                                </div>

                                <div class="row mt-2">
                                    <div class="col-md-8">
                                        <button href="javascript:void(0);" type="submit" class="btn btn-info my-1"
                                            (click)="onSubmit()" [disabled]="isDisabled">Save</button>
                                        <a href="javascript:void(0);" class="btn btn-danger ml-2 my-1"
                                            routerLink="/inquiry/inquirylist">Cancel</a>
                                    </div>
                                    <div *ngIf="drFlag==false && ReplicaRef==0"
                                        class="col-md-4 text-left text-sm-right">
                                        <button type="button" href="javascript:void(0);"
                                            class="btn-info border-info btn bg-info my-1"
                                            (click)="duplicate.show()">Duplicate</button>
                                        <button type="button" href="javascript:void(0);"
                                            class="btn btn-info bg-warning border-warning ml-2 my-1"
                                            (click)="replica.show()">Replica</button>
                                    </div>
                                </div>
                            </form>
                        </ng-template>
                    </ngb-tab>

                    <ngb-tab id="tab-selectbyid2">
                        <ng-template ngbTabTitle>
                            <div (click)="tabclick1(id)" *ngIf="permission.Inquiry_AttachmentUpload==1 || userRId==1">
                                Inquiry Document
                            </div>
                        </ng-template>
                        <ng-template ngbTabContent>
                            <app-inquirydocument></app-inquirydocument>
                        </ng-template>

                    </ngb-tab>
                </ngb-tabset>
            </div>
        </div>
    </div>
</div>

<!-- Duplicate Model -->
<div class="modal fade" bsModal #duplicate="bs-modal" [config]="{backdrop: 'static', keyboard: false}" tabindex="-1"
    role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content animated zoomIn">
            <div class="modal-header">
                <h4 id="dialog-static-name" class="modal-title pull-left">Are you sure to want perform this action ?
                </h4>
                <button type="button" class="close pull-right" aria-label="Close" (click)="duplicate.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form [formGroup]="duplicateForm">
                <div class="modal-body">

                    <div class="form-row animated fadeIn">
                        <div class="col-lg-12 mb-2">
                            <div>
                                <p>Project Name (ID): {{Pname}} ({{Pnumber}})</p>
                                <p>Inquiry Name (ID): {{Iname}} ({{Inumber}})</p>
                                <p>You are creating a duplicate inquiry, New inquiry number will be assigned !</p>
                            </div>
                            <label>Select Project Name: </label>
                            <angular2-multiselect formControlName="ProjectId" [data]="showProject"
                                [(ngModel)]="selectedproject" [settings]="dropdownSetting1"
                                (onSelect)="onProjectSelect($event)" (onDeSelect)="onProjectSelect($event)"
                                (onSelectAll)="onProjectSelect($event)" (onDeSelectAll)="onProjectSelect($event)"
                                fixSearchBug>
                            </angular2-multiselect>
                        </div>
                    </div>

                </div>
                <div class="modal-footer">
                    <button href="javascript:void(0);" type="submit" class="btn btn-sm btn btn-info"
                        (click)="getDuplicate()" [disabled]="isDisabled">Duplicate</button>
                    <a href="javascript:void(0);" class="btn btn-sm btn btn-secondary ml-2"
                        (click)="duplicate.hide()">Close</a>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Replica Model -->
<div class="modal fade" bsModal #replica="bs-modal" [config]="{backdrop: 'static', keyboard: false}" tabindex="-1"
    role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content animated zoomIn">
            <div class="modal-header">
                <h4 id="dialog-static-name" class="modal-title pull-left">Are you sure to want perform this action ?
                </h4>
                <button type="button" class="close pull-right" aria-label="Close" (click)="replica.hide()"><span
                        aria-hidden="true">&times;</span></button>
            </div>
            <div class="modal-body">
                <p>Project Name (ID): {{Pname}} ({{Pnumber}})</p>
                <p>Inquiry Name (ID): {{Iname}} ({{Inumber}})</p>
                <p>You are creating inquiry replica, inquiry number will be same and replica number will be generated,
                    Ex. "Current Inquirynumber-C"
                </p>
            </div>
            <div class="modal-footer">
                <button href="javascript:void(0);" type="submit" class="btn btn-sm btn btn-info" (click)="getReplica()"
                    [disabled]="isDisabled">Replica</button>
                <a href="javascript:void(0);" class="btn btn-sm btn btn-secondary ml-2"
                    (click)="replica.hide()">Close</a>
            </div>
        </div>
    </div>
</div>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>